<template>
  <section class="limited-offer-holder">
    <div class="container mobile-reset">
      <div class="row mobile-reset-row">
        <div class="col" :class="col.left">
          <div v-if="$slots.title" class="title">
            <slot name="title" />
          </div>
          <template v-else>
            <p class="title">
              <template v-if="$config.platform === 'ds'">
                Learn <strong class="highlight blue">DATA</strong> and <strong class="highlight blue">AI</strong>
              </template>
              <template v-else>
                Learn <strong class="highlight fa-blue">FINANCE</strong>
              </template>
              <span class="highlight-special">100% FOR <span class="mobile-block">FREE</span></span>
            </p>
            <p class="text-1">
              Through <span class="highlight yellow">NOV. 20</span>
            </p>
          </template>
          <div class="desktop-only">
            <p class="description" v-html="description" />
            <ul>
              <template v-if="benefits && benefits.length">
                <li v-for="(b, idx) in benefits" :key="idx">
                  <IconCheck /> <span v-html="b.name" />
                </li>
              </template>
              <template v-else>
                <li v-if="$config.platform === 'ds'">
                  <IconCheck /> Structured custom learning path
                </li>
                <li><IconCheck /> World-class instructors</li>
                <li><IconCheck /> Engaging bite-sized lessons</li>
                <li><IconCheck /> {{ stats.rounded.videoDuration }}+ hours of video</li>
                <li><IconCheck /> {{ stats.rounded.exercises }}+ practical exercises</li>
                <li><IconCheck /> Real-world {{ $config.platform === 'ds' ? 'data' : 'finance' }} projects</li>
                <li><IconCheck /> Hands-on exams</li>
                <li><IconCheck /> Certificates of achievement</li>
                <li><IconCheck /> Resume builder</li>
                <li><IconCheck /> Career guidance and support</li>
              </template>
            </ul>
          </div>
        </div>
        <div class="col mobile-reset-col" :class="col.right">
          <slot name="content" />
        </div>
      </div>
      <div class="mobile-only">
        <p class="description" v-html="description" />
        <ul>
          <li v-if="$config.platform === 'ds'">
            <IconCheck /> Structured custom learning path
          </li>
          <li><IconCheck /> World-class instructors</li>
          <li><IconCheck /> Engaging bite-sized lessons</li>
          <li><IconCheck /> {{ stats.rounded.videoDuration }}+ hours of video</li>
          <li><IconCheck /> {{ stats.rounded.exercises }}+ practical exercises</li>
          <li><IconCheck /> Real-world {{ $config.platform === 'ds' ? 'data' : 'finance' }} projects</li>
          <li><IconCheck /> Hands-on exams</li>
          <li><IconCheck /> Certificates of achievement</li>
          <li><IconCheck /> Resume builder</li>
          <li><IconCheck /> Career guidance and support</li>
        </ul>
      </div>
    </div>
    <img
      v-if="assets.background"
      v-show="$store.state.layout === 'desktop'"
      :src="require(`../../assets/images/campaigns/${assets.background}`)"
      class="limited-offer-background desktop-only"
    >
    <img
      v-if="assets.backgroundMobile"
      :src="require(`../../assets/images/campaigns/${assets.backgroundMobile}`)"
      class="limited-offer-background mobile-only"
    >
  </section>
</template>

<script>
import { col } from 'jstat';
import IconCheck from '../../assets/svg/icon-list-check.svg?vue-component';

export default {
  components: { IconCheck },
  props: {
    stats: { type: Object, default: () => ({}), required: true },
    assets: { type: Object, default: () => ({}), required: true },
    benefits: { type: Array, default: () => ([]), required: false },
    info: { type: Object, default: () => ({}), required: false },
    col: { type: Object, default: () => ({ left: 'col-5 offset-1', right: 'col-5' }), required: false },
  },
  computed: {
    description() {
      if (this.info.description) {
        return this.info.description;
      }

      if (this.$config.platform === 'fa') {
        return 'Join a financial training program that prepares you with the essential skills to thrive in the modern business field. Claim your <strong>unlimited FREE access</strong> to the entire 365 Financial Analyst platform.';
      }

      return 'Make the most of our university-grade training. Sign up for unlimited FREE access to the entire 365 Data Science platform.';
    },
  },
};
</script>

<style lang="scss" scoped>
.limited-offer-holder {
  position: relative;

  .col:first-child,
  ul,
  .mobile-only {
    color: var(--main-light);
  }

  .title {
    font-size: 32px;
    font-weight: 500;
    margin: 0;

    .highlight {
      font-size: 40px;
      font-weight: 800;
    }

    .highlight-special {
      display: block;
      font-size: 62px;
      font-weight: 700;
      line-height: 50px;
      margin-top: var(--spacing-8);
    }
  }

  .text-1 {
    margin: 0;
    font-size: 28px;

    .highlight {
      font-size: 30px;
      font-weight: 900;
    }
  }

  .description {
    margin-top: var(--spacing-32);
    margin-bottom: var(--spacing-16);
    font-size: 18px;
  }

  ul {
    list-style: none;
    padding: 0;
    font-size: 18px;
    font-weight: 600;

    li {
      display: flex;
      align-items: center;

      svg {
        margin-right: 14px;

        [fill] {
          fill: var(--extreme-yellow);
        }

        [stroke] {
          stroke: var(--extreme-yellow);
        }
      }

      + li {
        margin-top: var(--spacing-16);
      }
    }
  }

  .limited-offer-background {
    position: absolute;
    top: auto;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    z-index: -1;
  }

  @include bp($bp-laptop) {
    .title {
      font-size: 28px;

      .highlight {
        font-size: 32px;
      }

      .highlight-special {
        font-size: 48px;
      }
    }

    .text-1 {
      .highlight {
        font-size: 32px;
      }
    }

    ul {
      font-weight: 400;
    }
  }

  @include bp($bp-mobile) {
    padding-bottom: 100px;

    .title {
      text-align: center;

      .highlight-special {
        font-size: 66px;

        .mobile-block {
          display: block;
          margin-top: var(--spacing-16);
          font-size: 88px;
          line-height: 80px;
        }
      }
    }

    .text-1 {
      text-align: center;
      font-size: 24px;
      margin-top: var(--spacing-16);
      margin-bottom: 44px;

      .highlight {
        font-size: 28px;
      }
    }

    .col:first-child {
      padding-left: 24px;
      padding-right: 24px;
    }

    .description {
      margin-top: 44px;
      margin-bottom: var(--spacing-32);
    }

    div.mobile-only {
      padding: 0 24px;
    }

    .limited-offer-background {
      z-index: -2;
      top: 0;
      left: 50%;
      bottom: 0;
      width: 100%;
      object-fit: cover;
      object-position: top center;
    }
  }
}

.fa .limited-offer-holder .highlight-special {
  text-shadow: 0 0 16px rgba(252, 252, 83, 0.8);
}
</style>
